module.exports = __webpack_public_path__ + "static/media/globe.39a48327.ico";